export const validateUrl = (url: string) => {
  return (
    url
      .toLowerCase()
      .match(
        /([a-zA-Z0-9]):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
      ) || url === ''
  );
};
